var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-message-box',{attrs:{"title":"Access Denied","buttonLabel":"Login","action":_vm.handleLogin}},[_vm._v("\n  If you believe this is an error, please contact the system\n  administrator or try logging in again.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }